// Gift visibility based on subscription selection
document.addEventListener('DOMContentLoaded', function() {
  const subscriptionOptions = document.querySelectorAll('input[name="subscription_option"]');
  const giftsSection = document.querySelector('.subscription-gifts');
  const giftKnotBag = document.querySelector('.gift-item-knot-bag');
  const giftTumbler = document.querySelector('.gift-item-tumbler');
  const giftWaveStraw = document.querySelector('.gift-item-wave-straw');
  const giftShipping = document.querySelector('.gift-item-shipping');

  function updateGiftVisibility() {
    const selected = document.querySelector('input[name="subscription_option"]:checked');
    const tier = window.wildtypeSubscriptionTier.fromElement(selected);
    const isSubscription = tier === 'standard' || tier === 'duo' || tier === 'premium';

    if (giftsSection) giftsSection.style.display = isSubscription ? '' : 'none';
    if (giftKnotBag) giftKnotBag.style.display = isSubscription ? 'flex' : 'none';
    if (giftShipping) giftShipping.style.display = isSubscription ? 'flex' : 'none';
    if (giftTumbler) giftTumbler.style.display = tier === 'premium' ? 'flex' : 'none';
    if (giftWaveStraw) giftWaveStraw.style.display = (tier === 'premium' || tier === 'duo') ? 'flex' : 'none';
  }

  function updateGuaranteeTrustLabel() {
    const label = document.querySelector('[data-buybox-guarantee-label]');
    if (!label) return;
    const daysEl = label.querySelector('[data-guarantee-days]');
    if (!daysEl) return;
    const selected = document.querySelector('input[name="subscription_option"]:checked');
    const tier = window.wildtypeSubscriptionTier.fromElement(selected);
    const days = tier === 'premium' ? '90' : '30';
    daysEl.textContent = days + '-Day';
  }

  // Initial check
  updateGiftVisibility();
  updateGuaranteeTrustLabel();

  // Listen for changes
  subscriptionOptions.forEach(option => {
    option.addEventListener('change', function() {
      updateGiftVisibility();
      updateGuaranteeTrustLabel();
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.wildtype-hero__carousel');
  const items = carousel ? carousel.querySelectorAll('.wildtype-hero__carousel-item') : [];

  if (!carousel || items.length === 0) return;

  const carouselVideo = document.querySelector('.wildtype-hero__carousel-video');
  const carouselVideoSlide = carouselVideo?.closest('.wildtype-hero__carousel-item');
  const isMobile = () => window.innerWidth <= 768;
  const videoSlideIndex = carouselVideoSlide
    ? Array.from(items).indexOf(carouselVideoSlide)
    : -1;
  const buyboxFrontrowSticker = document.querySelector('.wildtype-buybox-main-image-wrap #frontrow-sticker');

  let currentIndex = 0;
  let autoScrollTimeout;
  let userInteracted = false;
  let scrollTimeout;
  let videoObserver;
  let videoEndHandler;
  let isFinishingVideoSlide = false;
  const SLIDE_INTERVAL_MS = 3500;
  const VIDEO_SLIDE_FALLBACK_MS = 10000;

  function getVideoSlideDurationMs() {
    if (!carouselVideo) return VIDEO_SLIDE_FALLBACK_MS;
    const duration = carouselVideo.duration;
    if (Number.isFinite(duration) && duration > 0) {
      return Math.ceil(duration * 1000);
    }
    return VIDEO_SLIDE_FALLBACK_MS;
  }

  function cleanupVideoEndListener() {
    if (videoEndHandler && carouselVideo) {
      carouselVideo.removeEventListener('ended', videoEndHandler);
      videoEndHandler = null;
    }
  }

  function configureCarouselVideoForViewport() {
    if (!carouselVideo) return;

    carouselVideo.muted = true;

    if (isMobile()) {
      carouselVideo.removeAttribute('controls');
      carouselVideo.setAttribute('loop', '');
      carouselVideo.setAttribute('preload', 'auto');
    } else {
      carouselVideo.setAttribute('controls', '');
      carouselVideo.setAttribute('loop', '');
      carouselVideo.setAttribute('preload', 'auto');
    }
  }

  function playCarouselVideo() {
    if (!carouselVideo) return;
    carouselVideo.muted = true;
    const playPromise = carouselVideo.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {});
    }
  }

  function pauseCarouselVideo() {
    if (!carouselVideo) return;
    carouselVideo.pause();
  }

  function syncCarouselVideo(index) {
    if (!carouselVideo) return;
    if (!isMobile()) {
      pauseCarouselVideo();
      return;
    }
    if (index === videoSlideIndex) {
      playCarouselVideo();
    } else {
      pauseCarouselVideo();
    }
  }

  function setupVideoObserver() {
    if (videoObserver) {
      videoObserver.disconnect();
      videoObserver = null;
    }

    if (!carouselVideo || !carouselVideoSlide || !isMobile()) return;

    if (!('IntersectionObserver' in window)) {
      pauseCarouselVideo();
      return;
    }

    videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            playCarouselVideo();
          } else {
            pauseCarouselVideo();
          }
        });
      },
      { root: carousel, threshold: [0, 0.5, 1] }
    );
    videoObserver.observe(carouselVideoSlide);
  }

  configureCarouselVideoForViewport();
  setupVideoObserver();
  setCurrentIndex(getCurrentIndex());

  // First slide stays left-aligned. Later slides lock in the center so neighbors only peek.
  function slideLockLeft(index) {
    const item = items[index];
    if (!item) return 0;
    const maxLeft = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
    let left = item.offsetLeft;
    if (isMobile() && index > 0) {
      left = item.offsetLeft - (carousel.clientWidth - item.offsetWidth) / 2;
    }
    return Math.max(0, Math.min(maxLeft, left));
  }

  carousel._wildtypeLockLeft = slideLockLeft;

  // Function to scroll to specific index
  function scrollToIndex(index) {
    const item = items[index];
    if (!item) return;
    carousel.scrollTo({
      left: slideLockLeft(index),
      behavior: 'smooth'
    });
    setCurrentIndex(index);
  }

  function updateBuyboxFrontrowForCarouselIndex(index) {
    if (!buyboxFrontrowSticker || !isMobile()) return;
    buyboxFrontrowSticker.classList.toggle('is-hidden', index !== 0);
  }

  function setCurrentIndex(index) {
    currentIndex = index;
    syncCarouselVideo(index);
    updateBuyboxFrontrowForCarouselIndex(index);
    warmSlides(index);
    document.querySelectorAll('.wildtype-hero__carousel-thumbs .wildtype-hero__carousel-thumb').forEach(function(thumb, i) {
      const isActive = i === index;
      thumb.classList.toggle('active', isActive);
      if (isActive && isMobile()) {
        const track = document.querySelector('.wildtype-hero__carousel-thumbs');
        if (!track) return;
        const trackRect = track.getBoundingClientRect();
        const thumbRect = thumb.getBoundingClientRect();
        if (thumbRect.left < trackRect.left) {
          track.scrollBy({ left: thumbRect.left - trackRect.left, behavior: 'smooth' });
        } else if (thumbRect.right > trackRect.right) {
          track.scrollBy({ left: thumbRect.right - trackRect.right, behavior: 'smooth' });
        }
      }
    });
    const thumbsPrev = document.querySelector('.wildtype-hero__thumbs-arrow--prev');
    const thumbsNext = document.querySelector('.wildtype-hero__thumbs-arrow--next');
    const thumbCount = document.querySelectorAll('.wildtype-hero__carousel-thumbs .wildtype-hero__carousel-thumb').length;
    if (thumbsPrev && thumbsNext && isMobile() && thumbCount > 1) {
      thumbsPrev.classList.remove('is-hidden');
      thumbsNext.classList.remove('is-hidden');
      thumbsPrev.disabled = false;
      thumbsNext.disabled = false;
    }
  }

  // Function to get current slide index based on scroll position
  function getCurrentIndex() {
    const scrollLeft = carousel.scrollLeft;
    let closestIndex = 0;
    let closestDistance = Infinity;

    items.forEach((item, index) => {
      const distance = Math.abs(item.offsetLeft - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  // Auto-scroll function
  function advanceSlide() {
    if (!userInteracted) {
      currentIndex = (currentIndex + 1) % items.length;
      scrollToIndex(currentIndex);
    }
    scheduleNextAutoScroll();
  }

  function finishVideoSlide() {
    if (isFinishingVideoSlide) return;
    isFinishingVideoSlide = true;
    cleanupVideoEndListener();
    clearTimeout(autoScrollTimeout);
    autoScrollTimeout = null;
    advanceSlide();
    isFinishingVideoSlide = false;
  }

  function scheduleVideoSlideAdvance() {
    cleanupVideoEndListener();
    clearTimeout(autoScrollTimeout);

    if (!carouselVideo) {
      autoScrollTimeout = setTimeout(advanceSlide, VIDEO_SLIDE_FALLBACK_MS);
      return;
    }

    carouselVideo.currentTime = 0;
    playCarouselVideo();

    videoEndHandler = finishVideoSlide;
    carouselVideo.addEventListener('ended', videoEndHandler, { once: true });
    autoScrollTimeout = setTimeout(finishVideoSlide, getVideoSlideDurationMs());
  }

  function scheduleNextAutoScroll() {
    cleanupVideoEndListener();
    clearTimeout(autoScrollTimeout);

    if (videoSlideIndex >= 0 && currentIndex === videoSlideIndex && carouselVideo && isMobile()) {
      scheduleVideoSlideAdvance();
      return;
    }

    autoScrollTimeout = setTimeout(advanceSlide, SLIDE_INTERVAL_MS);
  }

  function startAutoScroll() {
    stopAutoScroll();
    scheduleNextAutoScroll();
  }

  // Stop auto-scroll
  function stopAutoScroll() {
    cleanupVideoEndListener();
    clearTimeout(autoScrollTimeout);
    autoScrollTimeout = null;
  }

  // Detect manual scroll with debounce
  carousel.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);

    scrollTimeout = setTimeout(() => {
      const newIndex = getCurrentIndex();

      if (newIndex >= 0 && newIndex < items.length) {
        if (newIndex !== currentIndex) {
          setCurrentIndex(newIndex);
          userInteracted = true;

          // Resume auto-scroll after 5 seconds of no interaction
          stopAutoScroll();
        } else {
          syncCarouselVideo(newIndex);
        }
      }
    }, 100);
  });

  // Decode neighbors before they enter the clip. Lazy slides stay blank until centered.
  function warmSlides(index) {
    if (!isMobile()) return;
    [index - 1, index, index + 1, index + 2].forEach(function(i) {
      var slide = items[i];
      if (!slide) return;
      slide.querySelectorAll('img:not(.wildtype-hero__main-nav-icon)').forEach(function(img) {
        var wasLazy = img.loading === 'lazy';
        if (wasLazy) img.loading = 'eager';
        if (img.naturalWidth > 0) {
          if (typeof img.decode === 'function') img.decode().catch(function() {});
          return;
        }
        if (wasLazy) {
          var src = img.getAttribute('src');
          if (src) img.src = src;
        }
        if (typeof img.decode === 'function') img.decode().catch(function() {});
      });
      slide.querySelectorAll('video').forEach(function(video) {
        if (video.readyState >= 2) return;
        var wasAuto = video.preload === 'auto';
        video.preload = 'auto';
        if (!wasAuto && i !== index) video.load();
      });
    });
  }

  // pan-y keeps page scrolling. Move the slides inside the clip — translating the
  // carousel itself slides the clip away and leaves the next image blank.
  (function enableCarouselTouchScroll() {
    var startX = 0;
    var startY = 0;
    var startLeft = 0;
    var lastX = 0;
    var lastT = 0;
    var velocity = 0;
    var axis = null;
    var dragX = 0;
    var AXIS_LOCK_PX = 8;
    var SNAP_PX = 42;
    var SNAP_VEL = 0.45;
    var settling = false;
    var settleId = 0;

    function maxScroll() {
      return Math.max(0, carousel.scrollWidth - carousel.clientWidth);
    }

    function nearestIndex(targetLeft) {
      var closestIndex = 0;
      var closestDistance = Infinity;
      items.forEach(function(item, index) {
        var distance = Math.abs(slideLockLeft(index) - targetLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    }

    function setTranslate(x) {
      var value = x ? 'translate3d(' + x + 'px,0,0)' : '';
      for (var i = 0; i < items.length; i++) items[i].style.transform = value;
    }

    function clearTranslate() {
      carousel.style.transition = '';
      carousel.style.transform = '';
      carousel.style.willChange = '';
      setTranslate(0);
    }

    function stopSettle() {
      if (settleId) cancelAnimationFrame(settleId);
      settleId = 0;
      settling = false;
    }

    function animateToIndex(index, fromLeft) {
      stopSettle();
      clearTranslate();
      var target = slideLockLeft(index);
      var from = fromLeft;
      var start = performance.now();
      var dur = 280;
      settling = true;

      function step(now) {
        var t = Math.min(1, (now - start) / dur);
        var eased = 1 - Math.pow(1 - t, 3);
        carousel.scrollLeft = from + (target - from) * eased;
        if (t < 1) {
          settleId = requestAnimationFrame(step);
        } else {
          carousel.scrollLeft = target;
          settleId = 0;
          settling = false;
          setCurrentIndex(index);
          userInteracted = true;
          stopAutoScroll();
        }
      }

      settleId = requestAnimationFrame(step);
    }

    carousel.addEventListener('touchstart', function(e) {
      if (!isMobile() || e.touches.length !== 1) return;
      if (settling) {
        stopSettle();
        clearTranslate();
      }
      warmSlides(nearestIndex(carousel.scrollLeft));
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      lastX = startX;
      lastT = performance.now();
      velocity = 0;
      dragX = 0;
      startLeft = carousel.scrollLeft;
      axis = null;
    }, { passive: true });

    carousel.addEventListener('touchmove', function(e) {
      if (!isMobile() || e.touches.length !== 1) return;
      var x = e.touches[0].clientX;
      var y = e.touches[0].clientY;
      var dx = x - startX;
      var dy = y - startY;
      var now = performance.now();
      var dt = Math.max(8, now - lastT);
      velocity = (x - lastX) / dt;
      lastX = x;
      lastT = now;

      if (axis === null) {
        if (Math.abs(dx) < AXIS_LOCK_PX && Math.abs(dy) < AXIS_LOCK_PX) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'x') warmSlides(nearestIndex(startLeft));
      }

      if (axis !== 'x') return;
      if (e.cancelable) e.preventDefault();

      var visualLeft = startLeft - dx;
      var maxLeft = maxScroll();
      if (visualLeft < 0) visualLeft *= 0.32;
      else if (visualLeft > maxLeft) visualLeft = maxLeft + (visualLeft - maxLeft) * 0.32;
      dragX = startLeft - visualLeft;
      setTranslate(dragX);
    }, { passive: false });

    function finishSwipe() {
      if (axis !== 'x') {
        clearTranslate();
        axis = null;
        velocity = 0;
        return;
      }

      var visual = startLeft - dragX;
      var maxLeft = maxScroll();
      if (visual < 0) visual = 0;
      if (visual > maxLeft) visual = maxLeft;

      var origin = nearestIndex(startLeft);
      var dir = 0;
      if (Math.abs(dragX) >= SNAP_PX || Math.abs(velocity) >= SNAP_VEL) {
        dir = (Math.abs(velocity) >= SNAP_VEL ? velocity : dragX) < 0 ? 1 : -1;
      }
      var target = Math.max(0, Math.min(items.length - 1, origin + dir));

      axis = null;
      velocity = 0;
      clearTranslate();
      carousel.scrollLeft = visual;
      animateToIndex(target, visual);
    }

    carousel.addEventListener('touchend', finishSwipe, { passive: true });
    carousel.addEventListener('touchcancel', finishSwipe, { passive: true });
  })();

  // No auto-scroll on mobile — swipe only
  if (window.innerWidth <= 768) {
    syncCarouselVideo(getCurrentIndex());
  }

  // Handle window resize
  let wasMobileViewport = isMobile();
  window.addEventListener('resize', function() {
    const nowMobile = isMobile();
    configureCarouselVideoForViewport();
    setupVideoObserver();
    stopAutoScroll();

    // Desktop thumb-swap mutates slide 1; when returning to mobile, jump back to the real hero
    // so lifestyle slides don't appear twice in the swipe strip.
    if (nowMobile && !wasMobileViewport) {
      carousel.scrollLeft = 0;
      setCurrentIndex(0);
    }

    syncCarouselVideo(getCurrentIndex());
    updateBuyboxFrontrowForCarouselIndex(getCurrentIndex());
    wasMobileViewport = nowMobile;
  });
});

// Desktop thumbnail strip — swap main image on click / arrow nav
// Always init (not only on desktop) so desktop→mobile resize can restore the hero slide.
document.addEventListener('DOMContentLoaded', function() {
  const thumbsTrack = document.querySelector('.wildtype-hero__carousel-thumbs');
  const thumbs = Array.from(document.querySelectorAll('.wildtype-hero__carousel-thumbs .wildtype-hero__carousel-thumb'));
  const mainImgWrap = document.querySelector('.wildtype-hero__main-image');
  const prevBtn = document.querySelector('.wildtype-hero__main-nav--prev');
  const nextBtn = document.querySelector('.wildtype-hero__main-nav--next');
  const thumbsPrevBtn = document.querySelector('.wildtype-hero__thumbs-arrow--prev');
  const thumbsNextBtn = document.querySelector('.wildtype-hero__thumbs-arrow--next');
  const frontrowSticker = document.querySelector('.wildtype-buybox-main-image-wrap #frontrow-sticker');
  const carousel = document.querySelector('.wildtype-hero__carousel');
  if (!thumbs.length || !mainImgWrap) return;

  const initialMainImg = mainImgWrap.querySelector('img');
  const originalMainAlt = initialMainImg ? initialMainImg.alt : '';
  const THUMBS_VISIBLE = 5;

  if (thumbs.length < 2) {
    prevBtn?.classList.add('is-hidden');
    nextBtn?.classList.add('is-hidden');
  }

  function getThumbStep() {
    if (!thumbsTrack) return 0;
    const styles = window.getComputedStyle(thumbsTrack);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    const col = styles.gridAutoColumns;
    const colWidth = col && col !== 'auto' ? parseFloat(col) : 0;
    if (colWidth > 0) return colWidth + gap;
    const first = thumbs[0];
    if (!first) return 0;
    return first.getBoundingClientRect().width + gap;
  }

  function updateThumbsArrowState() {
    if (!thumbsPrevBtn || !thumbsNextBtn) return;
    if (!isMobileViewport() || thumbs.length < 2) {
      thumbsPrevBtn.classList.add('is-hidden');
      thumbsNextBtn.classList.add('is-hidden');
      return;
    }
    thumbsPrevBtn.classList.remove('is-hidden');
    thumbsNextBtn.classList.remove('is-hidden');
    thumbsPrevBtn.disabled = false;
    thumbsNextBtn.disabled = false;
  }

  function ensureThumbInView(thumb) {
    if (!thumbsTrack || !thumb) return;
    const trackRect = thumbsTrack.getBoundingClientRect();
    const thumbRect = thumb.getBoundingClientRect();
    if (thumbRect.left < trackRect.left - 1) {
      thumbsTrack.scrollBy({ left: thumbRect.left - trackRect.left, behavior: 'smooth' });
    } else if (thumbRect.right > trackRect.right + 1) {
      thumbsTrack.scrollBy({ left: thumbRect.right - trackRect.right, behavior: 'smooth' });
    }
  }

  function scrollThumbsStrip(direction) {
    if (!thumbsTrack) return;
    const step = getThumbStep() || Math.max(thumbsTrack.clientWidth / THUMBS_VISIBLE, 40);
    thumbsTrack.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  window.addEventListener('resize', function() {
    updateThumbsArrowState();
    if (isMobileViewport() && thumbsTrack) {
      // Keep the first 5 thumbs in view after resize
      if (thumbsTrack.scrollLeft > 0 && getActiveIndex() < THUMBS_VISIBLE) {
        thumbsTrack.scrollLeft = 0;
      }
    }
  });
  function resetThumbsStripToStart() {
    if (!thumbsTrack || !isMobileViewport()) return;
    thumbsTrack.scrollLeft = 0;
  }
  window.requestAnimationFrame(function() {
    updateThumbsArrowState();
    resetThumbsStripToStart();
  });
  window.setTimeout(function() {
    updateThumbsArrowState();
    resetThumbsStripToStart();
  }, 300);
  let isMainMediaAnimating = false;
  let pendingBtn = null;
  let pendingDirection = 0;
  let slideCleanupTimer = null;
  let slideTransitionHandler = null;
  let slideGeneration = 0;
  let wasMobileViewport = window.innerWidth <= 768;
  const MAIN_MEDIA_SLIDE_MS = 320;
  const MAIN_MEDIA_EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';
  const preloaded = new Map();

  function isMobileViewport() {
    return window.innerWidth <= 768;
  }

  function getActiveIndex() {
    const idx = thumbs.findIndex(function(t) { return t.classList.contains('active'); });
    return idx >= 0 ? idx : 0;
  }

  function getMainMediaNodes() {
    return Array.from(mainImgWrap.querySelectorAll(':scope > img, :scope > video.thumb-swap-video'));
  }

  function pauseMainMediaNode(node) {
    if (node && node.tagName === 'VIDEO') {
      node.pause();
    }
  }

  function createMainMediaNode(src, isVideo) {
    if (isVideo === 'true' || isVideo === true) {
      const vid = document.createElement('video');
      vid.src = src;
      vid.className = 'thumb-swap-video';
      vid.controls = true;
      vid.muted = true;
      vid.loop = true;
      vid.playsInline = true;
      vid.setAttribute('playsinline', '');
      vid.setAttribute('preload', 'auto');
      return vid;
    }

    const cached = preloaded.get(src);
    const img = document.createElement('img');
    img.src = cached && cached.complete ? cached.src : src;
    img.alt = originalMainAlt;
    img.decoding = 'async';
    img.draggable = false;
    return img;
  }

  function preloadThumb(src, isVideo) {
    if (!src || isVideo === 'true' || isVideo === true || preloaded.has(src)) return;
    const img = new Image();
    img.decoding = 'async';
    img.src = src;
    preloaded.set(src, img);
  }

  function preloadNearby(index) {
    const idxs = [index, index + 1, index - 1, index + 2];
    idxs.forEach(function(i) {
      const thumb = thumbs[(i + thumbs.length) % thumbs.length];
      if (!thumb) return;
      preloadThumb(thumb.dataset.src, thumb.dataset.isVideo);
    });
  }

  function playMainMediaNode(node) {
    if (!node || node.tagName !== 'VIDEO') return;
    node.muted = true;
    const playPromise = node.play();
    if (playPromise !== undefined) {
      playPromise.catch(function() {});
    }
  }

  function showMainMediaInstant(src, isVideo) {
    slideGeneration += 1;
    clearSlideCleanup();
    getMainMediaNodes().forEach(pauseMainMediaNode);
    mainImgWrap.querySelectorAll(':scope > .wildtype-hero__main-media-layer').forEach(function(layer) {
      layer.remove();
    });
    mainImgWrap.innerHTML = '';
    const media = createMainMediaNode(src, isVideo);
    mainImgWrap.appendChild(media);
    playMainMediaNode(media);
    mainImgWrap.style.minHeight = '';
    isMainMediaAnimating = false;
  }

  function clearSlideCleanup() {
    if (slideCleanupTimer) {
      window.clearTimeout(slideCleanupTimer);
      slideCleanupTimer = null;
    }
    if (slideTransitionHandler) {
      slideTransitionHandler.target.removeEventListener('transitionend', slideTransitionHandler.fn);
      slideTransitionHandler = null;
    }
  }

  function finishSlide(generation, outgoing, incoming, nextMedia) {
    if (generation !== slideGeneration) return;
    clearSlideCleanup();
    pauseMainMediaNode(outgoing.querySelector('video'));
    if (outgoing.parentNode) outgoing.remove();
    if (incoming.parentNode) {
      mainImgWrap.insertBefore(nextMedia, incoming);
      incoming.remove();
    }
    mainImgWrap.style.minHeight = '';
    playMainMediaNode(nextMedia);
    isMainMediaAnimating = false;

    if (pendingBtn) {
      const btn = pendingBtn;
      const direction = pendingDirection;
      pendingBtn = null;
      pendingDirection = 0;
      activateThumb(btn, direction);
    }
  }

  function runAfterPaint(fn) {
    // Firefox often batches the initial transform + transition in one frame;
    // double-rAF ensures the starting offset is committed first.
    requestAnimationFrame(function() {
      requestAnimationFrame(fn);
    });
  }

  function decodeMedia(node) {
    if (!node || node.tagName !== 'IMG' || typeof node.decode !== 'function') {
      return Promise.resolve();
    }
    return node.decode().catch(function() {});
  }

  function showMainMediaAnimated(src, isVideo, direction) {
    const generation = ++slideGeneration;
    isMainMediaAnimating = true;

    const currentNodes = getMainMediaNodes();
    const wrapHeight = mainImgWrap.offsetHeight;
    if (wrapHeight > 0) {
      mainImgWrap.style.minHeight = wrapHeight + 'px';
    }

    const outgoing = document.createElement('div');
    outgoing.className = 'wildtype-hero__main-media-layer is-outgoing';
    currentNodes.forEach(function(node) {
      outgoing.appendChild(node);
    });

    const incoming = document.createElement('div');
    incoming.className = 'wildtype-hero__main-media-layer is-incoming';
    const nextMedia = createMainMediaNode(src, isVideo);
    incoming.appendChild(nextMedia);

    const slideOffset = direction >= 0 ? '100%' : '-100%';
    const exitOffset = direction >= 0 ? '-100%' : '100%';

    // Set starting positions before mount so Firefox doesn't flash mid-frame
    outgoing.style.transform = 'translate3d(0, 0, 0)';
    incoming.style.transform = 'translate3d(' + slideOffset + ', 0, 0)';
    outgoing.style.transition = 'none';
    incoming.style.transition = 'none';

    mainImgWrap.appendChild(outgoing);
    mainImgWrap.appendChild(incoming);

    function startTransition() {
      if (generation !== slideGeneration) return;
      runAfterPaint(function() {
        if (generation !== slideGeneration) return;
        outgoing.style.transition = 'transform ' + MAIN_MEDIA_SLIDE_MS + 'ms ' + MAIN_MEDIA_EASING;
        incoming.style.transition = 'transform ' + MAIN_MEDIA_SLIDE_MS + 'ms ' + MAIN_MEDIA_EASING;
        outgoing.style.transform = 'translate3d(' + exitOffset + ', 0, 0)';
        incoming.style.transform = 'translate3d(0, 0, 0)';

        const onEnd = function(e) {
          if (e.target !== incoming || e.propertyName !== 'transform') return;
          finishSlide(generation, outgoing, incoming, nextMedia);
        };
        slideTransitionHandler = { target: incoming, fn: onEnd };
        incoming.addEventListener('transitionend', onEnd);
        slideCleanupTimer = window.setTimeout(function() {
          finishSlide(generation, outgoing, incoming, nextMedia);
        }, MAIN_MEDIA_SLIDE_MS + 80);
      });
    }

    decodeMedia(nextMedia).then(startTransition);
  }

  function updateFrontrowSticker(btn) {
    if (!frontrowSticker) return;
    frontrowSticker.classList.toggle('is-hidden', btn.dataset.index !== '0');
  }

  function activateThumb(btn, direction) {
    if (!btn) return;
    if (btn.classList.contains('active') && !isMainMediaAnimating) return;

    if (isMainMediaAnimating) {
      pendingBtn = btn;
      pendingDirection = direction === 1 || direction === -1 ? direction : 0;
      return;
    }

    thumbs.forEach(function(t) { t.classList.remove('active'); });
    btn.classList.add('active');
    preloadNearby(thumbs.indexOf(btn));
    ensureThumbInView(btn);

    if (direction === 1 || direction === -1) {
      showMainMediaAnimated(btn.dataset.src, btn.dataset.isVideo, direction);
    } else {
      showMainMediaInstant(btn.dataset.src, btn.dataset.isVideo);
    }

    updateFrontrowSticker(btn);
  }

  function goToOffset(delta) {
    if (isMobileViewport()) return;
    const nextIdx = (getActiveIndex() + delta + thumbs.length) % thumbs.length;
    activateThumb(thumbs[nextIdx], delta > 0 ? 1 : -1);
  }

  // Desktop swaps lifestyle into slide 1; mobile shows all slides. Always restore hero first.
  function resetToHeroForMobile() {
    pendingBtn = null;
    pendingDirection = 0;
    const heroThumb = thumbs[0];
    if (!heroThumb) return;

    thumbs.forEach(function(t) { t.classList.remove('active'); });
    heroThumb.classList.add('active');
    showMainMediaInstant(heroThumb.dataset.src, heroThumb.dataset.isVideo);
    updateFrontrowSticker(heroThumb);

    if (carousel) carousel.scrollLeft = 0;
  }

  function syncForDesktop() {
    const active = thumbs.find(function(t) { return t.classList.contains('active'); }) || thumbs[0];
    if (!active) return;
    showMainMediaInstant(active.dataset.src, active.dataset.isVideo);
    updateFrontrowSticker(active);
  }

  thumbs.forEach(function(btn) {
    preloadThumb(btn.dataset.src, btn.dataset.isVideo);
    btn.addEventListener('click', function() {
      const nextIdx = thumbs.indexOf(btn);
      if (nextIdx < 0) return;

      if (isMobileViewport()) {
        if (carousel) {
          const slide = carousel.querySelectorAll('.wildtype-hero__carousel-item')[nextIdx];
          if (slide) {
            carousel.scrollTo({ left: carousel._wildtypeLockLeft ? carousel._wildtypeLockLeft(nextIdx) : slide.offsetLeft, behavior: 'smooth' });
          }
        }
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        btn.classList.add('active');
        ensureThumbInView(btn);
        updateFrontrowSticker(btn);
        updateThumbsArrowState();
        return;
      }

      const currentIdx = getActiveIndex();
      if (nextIdx === currentIdx) return;
      let direction = nextIdx > currentIdx ? 1 : -1;
      if (currentIdx === thumbs.length - 1 && nextIdx === 0) direction = 1;
      if (currentIdx === 0 && nextIdx === thumbs.length - 1) direction = -1;
      activateThumb(btn, direction);
    });
  });

  prevBtn?.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    goToOffset(-1);
  });

  nextBtn?.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    goToOffset(1);
  });

  function navigateFromThumbsArrow(direction) {
    if (!isMobileViewport() || thumbs.length < 2) return;

    const currentIdx = getActiveIndex();
    const nextIdx = (currentIdx + direction + thumbs.length) % thumbs.length;
    const btn = thumbs[nextIdx];
    if (!btn) return;

    if (carousel) {
      const slide = carousel.querySelectorAll('.wildtype-hero__carousel-item')[nextIdx];
      if (slide) {
        carousel.scrollTo({ left: carousel._wildtypeLockLeft ? carousel._wildtypeLockLeft(nextIdx) : slide.offsetLeft, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    btn.classList.add('active');
    ensureThumbInView(btn);
    updateFrontrowSticker(btn);
    updateThumbsArrowState();
  }

  thumbsPrevBtn?.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    navigateFromThumbsArrow(-1);
  });

  thumbsNextBtn?.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    navigateFromThumbsArrow(1);
  });

  window.addEventListener('resize', function() {
    const nowMobile = isMobileViewport();
    if (nowMobile === wasMobileViewport) return;
    wasMobileViewport = nowMobile;

    if (nowMobile) {
      resetToHeroForMobile();
    } else {
      syncForDesktop();
    }
  });

  const initialThumb = thumbs.find(function(t) { return t.classList.contains('active'); }) || thumbs[0];
  updateFrontrowSticker(initialThumb);
  preloadNearby(getActiveIndex());

  // If the page loaded while a desktop session had already swapped media (bfcache / resize),
  // or we crossed into mobile before listeners attached, keep the strip de-duplicated.
  if (isMobileViewport() && getActiveIndex() !== 0) {
    resetToHeroForMobile();
  }
});
// Product form add to cart handling with Seal Subscriptions
document.addEventListener('DOMContentLoaded', function() {
  function buyboxBuildCartAddPayload(items) {
    // Skip requesting section HTML from cart/add.js. On a first add to an empty
    // cart Shopify often returns stale empty-drawer markup, so the UI looks like
    // nothing was added until a second click.
    return { items };
  }

  function buyboxCartAddUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';
  }

  async function buyboxPostCartAdd(items) {
    const response = await fetch(buyboxCartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buyboxBuildCartAddPayload(items)),
    });
    const data = await response.json();
    if (!response.ok || (data.status && data.status >= 400)) {
      throw new Error(data.description || data.message || 'Cart error');
    }
    return data;
  }

  function buyboxDispatchCartUpdate(data, sourceId) {
    const itemCount = (data.items && data.items[0]) ? data.items[0].quantity : (data.quantity || 1);
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: data,
        sourceId: sourceId || 'product-form-buybox',
        data: {
          source: 'product-form',
          itemCount,
        },
      },
    }));
  }

  window.buyboxBuildCartAddPayload = buyboxBuildCartAddPayload;
  window.buyboxDispatchCartUpdate = buyboxDispatchCartUpdate;

  const buyboxPlanMatchesOption = window.wildtypeSubscriptionTier.planMatchesLabel;
  const buyboxOptionHasSubscriptionGifts = window.wildtypeSubscriptionTier.labelHasGifts;
  const buyboxOptionHasPremiumGifts = window.wildtypeSubscriptionTier.labelHasPremiumGifts;
  const buyboxBillingMonths = window.wildtypeSubscriptionTier.billingMonths;
  const buyboxSubscriptionTier = window.buyboxSubscriptionTier;

  const productForm = document.querySelector('#product-form-buybox');
  const buyboxHero = productForm && productForm.closest('.wildtype-hero');
  const productJsonUrl =
    (buyboxHero && buyboxHero.dataset.buyboxProductJsonUrl) ||
    `${window.location.pathname}.js`;
  const variantInput = productForm && productForm.querySelector('input[name="id"]');
  const sellingPlanInput = productForm && productForm.querySelector('#selling-plan-input');
  const submitButton = productForm && productForm.querySelector('button[type="submit"]');
  const radioButtons = document.querySelectorAll('input[name="subscription_option"]');

  function buyboxPlanNameForId(productData, planId) {
    if (!productData || !productData.selling_plan_groups) return '';
    for (const group of productData.selling_plan_groups) {
      const plan = (group.selling_plans || []).find(p => String(p.id) === String(planId));
      if (plan) return plan.name || '';
    }
    return '';
  }

  function buyboxSignalsFromVariant(variant) {
    return {
      sku: variant?.sku || '',
      variantTitle: variant?.title || variant?.name || '',
    };
  }

  function buyboxAllocationMatchesOption(allocation, productData, optionTitle, sku, variantTitle) {
    const name = buyboxPlanNameForId(productData, allocation.selling_plan_id);
    return buyboxPlanMatchesOption(name, optionTitle, sku, variantTitle);
  }

  function buyboxIsLaborDayPlan(allocation, productData) {
    const id = String(allocation?.selling_plan_id || '');
    if (id === '703680151865' || id === '703680184633') return true;
    const name = (buyboxPlanNameForId(productData, allocation?.selling_plan_id) || '').toUpperCase();
    return name.includes('LABOR DAY');
  }

  function buyboxPickFromAllocations(allocations, productData) {
    if (!allocations || !allocations.length) return null;
    const usable = allocations.filter((a) => !buyboxIsLaborDayPlan(a, productData));
    const pool = usable.length ? usable : allocations;
    const discounted = pool.find((a) => a.compare_at_price > a.price);
    return discounted || pool[0] || null;
  }

  function buyboxPickAllocation(variant, explicitPlanId, productData) {
    const allocations = variant && variant.selling_plan_allocations;
    if (!allocations || !allocations.length) return null;
    const planId = explicitPlanId != null ? String(explicitPlanId).trim() : '';
    if (planId) {
      return allocations.find(a => String(a.selling_plan_id) === planId) || null;
    }
    return buyboxPickFromAllocations(allocations, productData);
  }

  function buyboxVariantFromId(productData, variantId) {
    if (!productData || variantId == null || variantId === '') return null;
    return productData.variants.find(v => v.id == variantId) || null;
  }

  /** Cart-valid variant + allocation; searches all variants when the template SKU has no plan. */
  function buyboxFindAllocationForOption(productData, optionTitle, preferredVariant, templateVariantId) {
    if (buyboxIsOnetimeOption(optionTitle)) return null;
    const tryVariant = (v) => {
      if (!v || !v.selling_plan_allocations || !v.selling_plan_allocations.length) return null;
      const identity = buyboxSignalsFromVariant(v);
      const isSubscription = buyboxOptionHasSubscriptionGifts(optionTitle, identity.sku, identity.variantTitle);
      let matches = v.selling_plan_allocations;
      if (isSubscription) {
        matches = matches.filter(a => buyboxAllocationMatchesOption(
          a, productData, optionTitle, identity.sku, identity.variantTitle
        ));
      }
      if (!matches.length) return null;
      const picked = buyboxPickFromAllocations(matches, productData);
      if (!picked) return null;
      return { variant: v, allocation: picked };
    };

    const tryVariantWithFallback = (v) => {
      const matched = tryVariant(v);
      if (matched) return matched;
      const fallbackAlloc = buyboxPickAllocation(v, '', productData);
      if (fallbackAlloc) {
        return { variant: v, allocation: fallbackAlloc };
      }
      return null;
    };

    const templateVariant = buyboxVariantFromId(productData, templateVariantId);
    if (templateVariant && (!preferredVariant || templateVariant.id !== preferredVariant.id)) {
      const onTemplate = tryVariantWithFallback(templateVariant);
      if (onTemplate) return onTemplate;
    }

    if (preferredVariant) {
      const onPreferred = tryVariantWithFallback(preferredVariant);
      if (onPreferred) return onPreferred;
    }

    for (const v of productData?.variants || []) {
      if (preferredVariant && v.id === preferredVariant.id) continue;
      if (templateVariant && v.id === templateVariant.id) continue;
      const found = tryVariant(v);
      if (found) return found;
    }
    return null;
  }

  function buyboxIsOnetimeOption(optionTitle, radio) {
    return /one\s*time/i.test(String(optionTitle || ''))
      || (radio && radio.getAttribute('data-subscription-tier') === 'onetime');
  }

  function buyboxResolveCartPair(variant, explicitPlanId, productData, optionTitle, templateVariantId) {
    const preferred = variant || null;
    if (buyboxIsOnetimeOption(optionTitle)) {
      return {
        variantId: preferred ? String(preferred.id) : '',
        sellingPlanId: '',
        variant: preferred,
        allocation: null
      };
    }
    const found = productData
      ? buyboxFindAllocationForOption(productData, optionTitle, preferred, templateVariantId)
      : null;
    if (found) {
      return {
        variantId: String(found.variant.id),
        sellingPlanId: String(found.allocation.selling_plan_id),
        variant: found.variant,
        allocation: found.allocation
      };
    }
    const allocation = buyboxPickAllocation(preferred, explicitPlanId, productData);
    if (allocation && preferred) {
      return {
        variantId: String(preferred.id),
        sellingPlanId: String(allocation.selling_plan_id),
        variant: preferred,
        allocation
      };
    }
    return {
      variantId: preferred ? String(preferred.id) : '',
      sellingPlanId: '',
      variant: preferred,
      allocation: null
    };
  }

  function buyboxResolveSellingPlanId(variant, explicitPlanId, productData, optionTitle, templateVariantId) {
    return buyboxResolveCartPair(variant, explicitPlanId, productData, optionTitle, templateVariantId).sellingPlanId;
  }

  function buyboxApplyCartPairToRadio(radio, pair) {
    if (!radio || !pair.variantId) return;
    radio.setAttribute('data-variant-id', pair.variantId);
    radio.setAttribute('data-selling-plan-id', pair.sellingPlanId || '');
  }

  function buyboxOptionIsSubscription(optionTitle, sku, variantTitle) {
    return buyboxOptionHasSubscriptionGifts(optionTitle, sku, variantTitle);
  }

  /** Sync hidden form fields from radio data attributes (before product JSON loads). */
  function buyboxSyncFormFromRadioAttributes(radio) {
    if (!radio) return;
    const variantId = radio.getAttribute('data-variant-id');
    const planId = radio.getAttribute('data-selling-plan-id') || '';
    if (variantId && variantInput) variantInput.value = variantId;
    if (sellingPlanInput) {
      sellingPlanInput.value = buyboxOptionIsSubscription(
        radio.value,
        radio.dataset?.variantSku,
        radio.dataset?.variantTitle
      ) ? planId : '';
    }
  }

  function buyboxEnsureProduct() {
    if (product) return Promise.resolve(product);
    return fetch(productJsonUrl)
      .then(response => response.json())
      .then(fetchedProduct => {
        product = fetchedProduct;
        return product;
      });
  }

  /** Resolve cart-valid variant + plan and sync radio + hidden inputs. */
  function buyboxSyncFormFromRadio(radio, productData) {
    if (!radio || !productData) return null;
    const optionTitle = radio.value || '';
    if (buyboxIsOnetimeOption(optionTitle, radio)) {
      const variantId = radio.getAttribute('data-variant-id') || '';
      const variant = buyboxVariantFromId(productData, variantId)
        || buyboxVariantFromId(productData, radio.getAttribute('data-template-variant-id'));
      const pair = {
        variantId: variant ? String(variant.id) : variantId,
        sellingPlanId: '',
        variant: variant,
        allocation: null
      };
      buyboxApplyCartPairToRadio(radio, pair);
      if (variantInput && pair.variantId) variantInput.value = pair.variantId;
      if (sellingPlanInput) sellingPlanInput.value = '';
      return pair;
    }
    const templateVariantId = radio.getAttribute('data-template-variant-id');
    const variant = buyboxVariantFromId(productData, radio.getAttribute('data-variant-id'))
      || buyboxVariantFromId(productData, templateVariantId);
    if (!variant) return null;

    const pair = buyboxResolveCartPair(
      variant,
      radio.getAttribute('data-selling-plan-id'),
      productData,
      optionTitle,
      templateVariantId
    );
    buyboxApplyCartPairToRadio(radio, pair);
    if (variantInput && pair.variantId) variantInput.value = pair.variantId;
    if (sellingPlanInput) {
      sellingPlanInput.value = (buyboxOptionIsSubscription(
        optionTitle,
        radio.dataset?.variantSku || variant?.sku,
        radio.dataset?.variantTitle || variant?.title
      ) && pair.sellingPlanId)
        ? pair.sellingPlanId
        : '';
    }
    return pair;
  }

  function buyboxSubscriptionSalePriceCents(variant, explicitPlanId, optionTitle, productData) {
    if (buyboxIsOnetimeOption(optionTitle)) {
      return variant ? variant.price : 0;
    }
    const pair = buyboxResolveCartPair(variant, explicitPlanId, productData, optionTitle);
    const pricingVariant = pair.variant || variant;
    const allocation = pair.allocation;
    if (!pricingVariant) return 0;

    let priceCents = pricingVariant.price;

    if (allocation) {
      priceCents = allocation.price;
      if (allocation.compare_at_price > allocation.price) {
        return priceCents;
      }
      if (allocation.price_adjustments && allocation.price_adjustments.length) {
        const lastAdj = allocation.price_adjustments[allocation.price_adjustments.length - 1];
        if (lastAdj.price != null && lastAdj.price < priceCents) {
          return lastAdj.price;
        }
      }
      return priceCents;
    }

    const identity = buyboxSignalsFromVariant(pricingVariant);
    const months = buyboxBillingMonths(optionTitle, identity.sku, identity.variantTitle);
    if (months === 3) return Math.round(pricingVariant.price * 0.7);
    if (months === 2) return Math.round(pricingVariant.price * 0.75);
    if (months >= 1) return Math.round(pricingVariant.price * 0.8);
    return priceCents;
  }

  function buyboxUpdateSubmitButton(optionTitle, priceCents, sku, variantTitle) {
    if (!submitButton) return;
    submitButton.textContent = 'ADD TO CART';
  }

  let product = null;

  function buyboxApplyUrlSelection() {
    const selection = (new URLSearchParams(window.location.search).get('selection') || '')
      .toLowerCase()
      .replace(/[-_\s]/g, '');
    if (selection !== '3month') return;

    const radios = Array.from(document.querySelectorAll('input[name="subscription_option"]'));
    const target = radios.find((radio) => radio.getAttribute('data-subscription-tier') === 'premium')
      || radios.find((radio) => /3[\s-]?month/i.test(radio.value || ''));
    if (target) target.checked = true;
  }
  buyboxApplyUrlSelection();

  const checkedRadioOnLoad = document.querySelector('input[name="subscription_option"]:checked');
  if (checkedRadioOnLoad) {
    buyboxSyncFormFromRadioAttributes(checkedRadioOnLoad);
  }

  // Smooth load: reveal pricing area after first paint
  const pricingReveal = document.querySelector('.buybox-pricing-reveal');
  if (pricingReveal) {
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        pricingReveal.classList.add('buybox-loaded');
      });
    });
  }

  // Fetch product data once and populate all pricing displays
  fetch(productJsonUrl)
    .then(response => response.json())
    .then(fetchedProduct => {
      product = fetchedProduct;
      if (!product || !Array.isArray(product.variants)) {
        console.warn('Buybox: expected product JSON at', productJsonUrl);
        return;
      }
      // Populate pricing displays for each option
      document.querySelectorAll('.pricing-display').forEach(display => {
        const variantId = display.getAttribute('data-variant-id');
        const explicitPlanId = display.getAttribute('data-selling-plan-id');

        const variant = product.variants.find(v => v.id == variantId);
        if (variant) {
          const radio = display.closest('.subscription-option')?.querySelector('input[name="subscription_option"]');
          const optionTitle = radio?.value || display.closest('.subscription-top-row')?.querySelector('.option-title-text')?.textContent || '';
          if (buyboxIsOnetimeOption(optionTitle, radio)) return;
          const templateVariantId = radio ? radio.getAttribute('data-template-variant-id') : null;
          const pair = buyboxResolveCartPair(variant, explicitPlanId, product, optionTitle, templateVariantId);
          if (pair.sellingPlanId) {
            display.setAttribute('data-selling-plan-id', pair.sellingPlanId);
            display.setAttribute('data-variant-id', pair.variantId);
          }
          buyboxApplyCartPairToRadio(radio, pair);
          const pricingVariant = pair.variant || variant;
          let salePrice = buyboxSubscriptionSalePriceCents(pricingVariant, pair.sellingPlanId, optionTitle, product);
          let discountPercent = 0;
          if (salePrice < pricingVariant.price) {
            discountPercent = Math.round((1 - salePrice / pricingVariant.price) * 100);
          }

          // Update display (badge lives in the title row, sibling of pricing-display)
          const discountBadge = display.closest('.subscription-top-row')?.querySelector('.discount-badge');
          const originalPrice = display.querySelector('.original-price');
          const salePriceEl = display.querySelector('.sale-price-amount');
          const months = buyboxBillingMonths(
            optionTitle,
            radio?.dataset?.variantSku || pricingVariant?.sku,
            radio?.dataset?.variantTitle || pricingVariant?.title
          );
          if (months === 3) {
            discountPercent = Math.max(discountPercent, 30);
          } else if (months === 2) {
            discountPercent = Math.max(discountPercent, 25);
          }

          const packLayout = document.querySelector('.wildtype-hero[data-pricing-layout^="pack"]');
          const billedMonths = parseInt(display.getAttribute('data-billing-months') || months || '1', 10) || 1;

          if (discountPercent > 0) {
            if (discountBadge) {
              discountBadge.textContent = `SAVE ${discountPercent}%`;
              discountBadge.style.display = 'inline-block';
            }
            if (!packLayout && originalPrice && salePrice < pricingVariant.price) {
              originalPrice.innerHTML = `<span style="text-decoration: line-through;">$${(pricingVariant.price / 100).toFixed(0)}</span>/mo`;
              originalPrice.style.display = 'inline';
            }
          } else if (!packLayout) {
            if (discountBadge) discountBadge.style.display = 'none';
            if (originalPrice) originalPrice.style.display = 'none';
          }

          if (packLayout) {
            const packTotal = Math.round(salePrice / 100);
            if (salePriceEl) salePriceEl.textContent = `$${packTotal}`;
            const perDayEl = display.querySelector('.buybox-pack-per-day');
            if (perDayEl) {
              const perDay = (salePrice / 100) / billedMonths / 30;
              perDayEl.textContent = `$${perDay.toFixed(2)} / day`;
            }
          } else {
          const pricePerMonth = Math.round((salePrice / 100) / months);
          salePriceEl.textContent = `$${pricePerMonth}`;
          }

          const deliveryRow = display.closest('.subscription-top-row')?.querySelector('.delivery-row');
          const billedEl = deliveryRow?.querySelector('.delivery-info-text:not(#serving)');
          const servingEl = deliveryRow?.querySelector('#serving');
          if (billedEl && months >= 1) {
            const weeks = months * 4;
            billedEl.textContent = `$${Math.round(salePrice / 100)} USD every ${weeks} weeks`;
          }
          if (servingEl && months >= 1) {
            const perDay = (salePrice / 100) / months / 30;
            servingEl.textContent = packLayout ? `$${perDay.toFixed(2)} / day` : `$${perDay.toFixed(2)}/day`;
          }
        }
      });

      const checkedRadio = document.querySelector('input[name="subscription_option"]:checked');
      if (checkedRadio) {
        const checkedPair = buyboxSyncFormFromRadio(checkedRadio, product);
        if (checkedPair) {
          const checkedPrice = buyboxSubscriptionSalePriceCents(
            checkedPair.variant,
            checkedPair.sellingPlanId,
            checkedRadio.value || '',
            product
          );
          buyboxUpdateSubmitButton(
            checkedRadio.value || '',
            checkedPrice,
            checkedRadio.dataset?.variantSku || checkedPair.variant?.sku,
            checkedRadio.dataset?.variantTitle || checkedPair.variant?.title
          );
        }
      }

      // Populate one-time purchase price (unit price for strikethroughs; pack OTP link updated separately)
      const oneTimeLink = document.querySelector('.one-time-purchase-link');
      let oneTimePriceDollars = null;
      if (oneTimeLink) {
        const unitFromData = parseInt(oneTimeLink.getAttribute('data-onetime-price-1') || oneTimeLink.getAttribute('data-unit-price') || '0', 10) || 0;
        const variantId = oneTimeLink.getAttribute('data-onetime-variant-1') || oneTimeLink.getAttribute('data-variant-id');
        const variant = product.variants.find(v => v.id == variantId);
        if (unitFromData) {
          oneTimePriceDollars = unitFromData;
        } else if (variant) {
          oneTimePriceDollars = Math.round(variant.price / 100);
        }
        if (oneTimePriceDollars !== null && !oneTimeLink.hasAttribute('data-onetime-variant-1')) {
          const oneTimePrice = document.querySelector('.one-time-price');
          if (oneTimePrice) {
            oneTimePrice.textContent = `$${oneTimePriceDollars}`;
          }
        }
      }

      // Set subscription card original-price to one-time purchase price
      if (oneTimePriceDollars !== null) {
        document.querySelectorAll('.pricing-display').forEach(display => {
          const sellingPlanId = display.getAttribute('data-selling-plan-id');
          if (!sellingPlanId) return;

          const originalPrice = display.querySelector('.original-price');
          if (originalPrice) {
            const months = parseInt(display.getAttribute('data-billing-months') || '1', 10) || 1;
            const originalTotal = oneTimePriceDollars * months;
            const strikeSpan = originalPrice.querySelector('span');
            if (strikeSpan) {
              strikeSpan.textContent = `$${originalTotal}`;
            } else {
              originalPrice.innerHTML = `<span style="text-decoration: line-through;">$${originalTotal}</span>/mo`;
            }
            originalPrice.style.display = 'inline';
          }
        });
      }

      if (typeof updateOnetimePackDisplay === 'function') {
        updateOnetimePackDisplay();
      }
    })
    .catch(error => {
      console.error('Error fetching product data:', error);
    });

  // Handle variant and selling plan switching when radio button changes
  radioButtons.forEach(radio => {
    radio.addEventListener('change', function() {
      const optionTitleForPrice = this.value || '';
      if (product) {
        const pair = buyboxSyncFormFromRadio(this, product);
        if (pair) {
          buyboxUpdateSubmitButton(
            optionTitleForPrice,
            buyboxSubscriptionSalePriceCents(pair.variant, pair.sellingPlanId, optionTitleForPrice, product),
            this.dataset?.variantSku || pair.variant?.sku,
            this.dataset?.variantTitle || pair.variant?.title
          );
        }
      } else {
        buyboxSyncFormFromRadioAttributes(this);
      }
    });
  });

  // Benefits section expand/collapse via JS (more reliable than CSS :checked alone)
  function updateBenefitsVisibility() {
    const packTabsLayout = document.querySelector('.buybox-pricing-layout--pack_tabs');
    const isPackLayout = document.querySelector('.wildtype-hero[data-pricing-layout^="pack"]');
    document.querySelectorAll('input[name="subscription_option"]').forEach(function(radio) {
      const card = radio.nextElementSibling;
      const benefitsSection = card && card.querySelector('.benefits-section');
      if (!benefitsSection) return;
      const option = radio.closest('.subscription-option');
      if (packTabsLayout && option && option.classList.contains('is-active-pack')) {
        benefitsSection.style.maxHeight = '900px';
        return;
      }
      benefitsSection.style.maxHeight = radio.checked ? (isPackLayout ? '900px' : '600px') : '0';
    });
  }
  updateBenefitsVisibility();
  radioButtons.forEach(function(radio) {
    radio.addEventListener('change', updateBenefitsVisibility);
  });

  const packTabs = document.querySelectorAll('.buybox-pack-tab');
  const onetimeOption = document.querySelector('.buybox-onetime-option');
  const onetimeLink = document.querySelector('.one-time-purchase-link');
  const quantityInput = document.getElementById('buybox-quantity');

  function getActivePackMonths() {
    const tab = document.querySelector('.buybox-pack-tab.is-selected');
    let tier = tab ? tab.getAttribute('data-subscription-tier') : '';
    if (!tier) {
      const selected = document.querySelector('input[name="subscription_option"]:checked');
      tier = selected ? (selected.getAttribute('data-subscription-tier') || '') : '';
    }
    if (tier === 'premium') return 3;
    if (tier === 'duo') return 2;
    return 1;
  }

  function isOnetimeSelected() {
    const selected = document.querySelector('input[name="subscription_option"]:checked');
    return !!(selected && buyboxIsOnetimeOption(selected.value, selected));
  }

  /** Source for dedicated one-time pack variants: VA card or VB link. */
  function getOnetimePackSource() {
    return onetimeOption || onetimeLink;
  }

  /** Dedicated one-time variant for a pack size, when the product has one. */
  function getOnetimePackVariant(months) {
    const source = getOnetimePackSource();
    if (!source) return null;
    const variantId = source.getAttribute('data-onetime-variant-' + months);
    const price = parseInt(source.getAttribute('data-onetime-price-' + months) || '0', 10) || 0;
    if (!variantId || !price) return null;
    return { variantId: variantId, price: price };
  }

  function updateOnetimePackDisplay() {
    const packLayout = document.querySelector('.wildtype-hero[data-pricing-layout^="pack"]');
    const source = getOnetimePackSource();
    if (!source) return;

    // Control (default stacked cards): always the 1-pack one-time price, never 2/3-pack totals.
    if (!packLayout) {
      if (onetimeLink) {
        const onePackId = onetimeLink.getAttribute('data-onetime-variant-1') || onetimeLink.getAttribute('data-variant-id');
        const onePackPrice = parseInt(onetimeLink.getAttribute('data-onetime-price-1') || onetimeLink.getAttribute('data-unit-price') || '0', 10) || 0;
        if (onePackId) onetimeLink.setAttribute('data-variant-id', onePackId);
        const fullPrice = onePackPrice;
        const salePrice = fullPrice ? Math.round(fullPrice * 0.8) : 0;
        const linkPriceEl = onetimeLink.querySelector('.one-time-price');
        const compareEl = onetimeLink.querySelector('.one-time-compare');
        if (linkPriceEl && salePrice) linkPriceEl.textContent = '$' + salePrice;
        if (compareEl) {
          compareEl.hidden = !(fullPrice > salePrice);
          compareEl.textContent = fullPrice > salePrice ? '$' + fullPrice : '';
        }
      }
      return;
    }

    const months = getActivePackMonths();
    const unit = parseInt(source.getAttribute('data-unit-price') || '0', 10) || 0;
    const packVariant = getOnetimePackVariant(months);
    const total = packVariant ? packVariant.price : unit * months;
    const perDay = Math.round((total / (30 * months)) * 100) / 100;

    if (onetimeOption) {
      const radio = onetimeOption.querySelector('input[name="subscription_option"]');
      if (radio && packVariant) {
        radio.setAttribute('data-variant-id', packVariant.variantId);
        radio.setAttribute('data-template-variant-id', packVariant.variantId);
        radio.setAttribute('data-selling-plan-id', '');
        if (radio.checked) buyboxSyncFormFromRadioAttributes(radio);
      }
      const priceEl = onetimeOption.querySelector('.buybox-onetime-price');
      const perDayEl = onetimeOption.querySelector('.buybox-onetime-per-day');
      const subEl = onetimeOption.querySelector('.buybox-onetime-sub');
      if (priceEl) priceEl.textContent = '$' + total;
      if (perDayEl) perDayEl.textContent = '$' + perDay + ' / day';
      if (subEl) subEl.textContent = 'No free shipping or gifts';
      if (quantityInput) {
        quantityInput.value = isOnetimeSelected() ? String(packVariant ? 1 : months) : '1';
      }
    }

    if (onetimeLink) {
      const linkVariantId = packVariant
        ? packVariant.variantId
        : (onetimeLink.getAttribute('data-onetime-variant-1') || onetimeLink.getAttribute('data-variant-id'));
      if (linkVariantId) onetimeLink.setAttribute('data-variant-id', linkVariantId);
      onetimeLink.setAttribute('data-pack-months', String(months));
      const linkPriceEl = onetimeLink.querySelector('.one-time-price');
      if (linkPriceEl) linkPriceEl.textContent = '$' + total;
    }
  }

  function syncActivePackFromRadio(radio) {
    if (!radio) return;
    if (!packTabs.length) {
      updateOnetimePackDisplay();
      return;
    }
    if (/one time/i.test(radio.value || '')) {
      updateOnetimePackDisplay();
      return;
    }
    const blockId = radio.closest('.subscription-option')?.getAttribute('data-block-id');
    document.querySelectorAll('.buybox-subscription-options > .subscription-option').forEach(function(option) {
      option.classList.toggle('is-active-pack', option.getAttribute('data-block-id') === blockId);
    });
    packTabs.forEach(function(tab) {
      const selected = tab.getAttribute('data-pack-target') === blockId;
      tab.classList.toggle('is-selected', selected);
      tab.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    updateOnetimePackDisplay();
  }
  packTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const blockId = tab.getAttribute('data-pack-target');
      const option = document.querySelector('.subscription-option[data-block-id="' + blockId + '"]');
      const radio = option && option.querySelector('input[name="subscription_option"]');
      if (!radio) return;
      document.querySelectorAll('.buybox-subscription-options > .subscription-option').forEach(function(opt) {
        opt.classList.toggle('is-active-pack', opt.getAttribute('data-block-id') === blockId);
      });
      packTabs.forEach(function(other) {
        const selected = other === tab;
        other.classList.toggle('is-selected', selected);
        other.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      if (!isOnetimeSelected()) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateOnetimePackDisplay();
      updateBenefitsVisibility();
    });
  });
  radioButtons.forEach(function(radio) {
    radio.addEventListener('change', function() {
      syncActivePackFromRadio(this);
    });
  });
  updateOnetimePackDisplay();

  if (productForm) {
    productForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      if (submitButton.disabled) return;

      let variantId = variantInput.value;
      let sellingPlanId = (sellingPlanInput && sellingPlanInput.value) ? sellingPlanInput.value.trim() : '';
      const quantity = parseInt(productForm.querySelector('input[name="quantity"]')?.value || 1, 10) || 1;
      const originalText = submitButton.textContent;

      const selectedOption = document.querySelector('input[name="subscription_option"]:checked');
      const optionTitleRaw = selectedOption ? (selectedOption.value || '') : '';
      const isOnetime = /one\s*time/i.test(optionTitleRaw)
        || (selectedOption && selectedOption.getAttribute('data-subscription-tier') === 'onetime');
      const selectedTier = isOnetime ? null : window.wildtypeSubscriptionTier.fromElement(selectedOption);

      submitButton.disabled = true;
      submitButton.textContent = 'ADDING...';

      if (isOnetime) {
        sellingPlanId = '';
        if (sellingPlanInput) sellingPlanInput.value = '';
        const otpVariantId = selectedOption && selectedOption.getAttribute('data-variant-id');
        if (otpVariantId) {
          variantId = otpVariantId;
          if (variantInput) variantInput.value = otpVariantId;
        }
      } else if (selectedOption && optionTitleRaw) {
        try {
          const productData = await buyboxEnsureProduct();
          const pair = buyboxSyncFormFromRadio(selectedOption, productData);
          if (pair && pair.variantId) {
          variantId = pair.variantId;
            if (pair.sellingPlanId) sellingPlanId = pair.sellingPlanId;
          }
        } catch (err) {
          console.error('Buybox: failed to load product JSON', err);
        }

        if (!variantId || !sellingPlanId) {
          buyboxSyncFormFromRadioAttributes(selectedOption);
          variantId = variantInput.value;
          sellingPlanId = (sellingPlanInput && sellingPlanInput.value) ? sellingPlanInput.value.trim() : '';
        }

        if (!variantId || !sellingPlanId) {
          console.error('Buybox: no selling plan allocation for', optionTitleRaw);
            submitButton.textContent = 'ERROR - TRY AGAIN';
          setTimeout(() => {
            submitButton.textContent = originalText;
            submitButton.disabled = false;
          }, 2000);
            return;
        }
      }

      const shippingGifts = document.querySelector('.wildtype-hero')?.dataset.shippingGifts === 'true';
      const knotBagSkus = shippingGifts
        ? [67583119098169, 67583126470969]
        : [54353647731001, 54353646420281];
      const tumblerSku = shippingGifts ? 67583115690297 : 54353644880185;
      const waveStrawSkus = shippingGifts
        ? [67583131124025, 67583133385017]
        : [54353638392121, 54353640784185];
      const knotBagPresentIds = [54353647731001, 54353646420281, 67583119098169, 67583126470969];
      const tumblerPresentIds = [54353644880185, 67583115690297];
      const strawPresentIds = [54353638392121, 54353640784185, 67583131124025, 67583133385017];
      const randomKnotBag = knotBagSkus[Math.floor(Math.random() * knotBagSkus.length)];
      const randomWaveStraw = waveStrawSkus[Math.floor(Math.random() * waveStrawSkus.length)];

      const parsedVariantId = parseInt(variantId, 10);
      if (!parsedVariantId) {
        submitButton.textContent = 'ERROR - TRY AGAIN';
        setTimeout(() => {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }, 2000);
        return;
      }

      const productItem = { id: parsedVariantId, quantity: quantity };
      if (sellingPlanId !== '') {
        productItem.selling_plan = parseInt(sellingPlanId, 10);
      }

      try {
        const data = await buyboxPostCartAdd([productItem]);

        if (selectedTier === 'standard' || selectedTier === 'duo' || selectedTier === 'premium') {
          const giftItems = [];
          try {
            const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            const cartRes = await fetch(cartRoot + 'cart.js');
          const cartData = await cartRes.json();
            const cartHasKnotBag = cartData.items && cartData.items.some(ci => knotBagPresentIds.includes(ci.variant_id));
            const cartHasTumbler = cartData.items && cartData.items.some(ci => tumblerPresentIds.includes(ci.variant_id));
            const cartHasStraw = cartData.items && cartData.items.some(ci => strawPresentIds.includes(ci.variant_id));
            if (!cartHasKnotBag) giftItems.push({ id: randomKnotBag, quantity: 1 });
            if ((selectedTier === 'duo' || selectedTier === 'premium') && !cartHasStraw) {
              giftItems.push({ id: randomWaveStraw, quantity: 1 });
            }
            if (selectedTier === 'premium' && !cartHasTumbler) {
              giftItems.push({ id: tumblerSku, quantity: 1 });
            }
          } catch (giftLookupError) {
            giftItems.push({ id: randomKnotBag, quantity: 1 });
            if (selectedTier === 'duo' || selectedTier === 'premium') {
              giftItems.push({ id: randomWaveStraw, quantity: 1 });
            }
          if (selectedTier === 'premium') {
              giftItems.push({ id: tumblerSku, quantity: 1 });
            }
          }

          if (giftItems.length) {
            try {
              await buyboxPostCartAdd(giftItems);
            } catch (giftError) {
              console.error('Buybox: gifts failed after product was added', giftError);
            }
          }
        }

        submitButton.textContent = 'ADDED!';
        buyboxDispatchCartUpdate(data, 'product-form-buybox');
        setTimeout(() => {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }, 2000);
      } catch (error) {
        console.error('Error:', error);
        submitButton.textContent = 'ERROR - TRY AGAIN';
        setTimeout(() => {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }, 2000);
      }
    });
  }
});

// FAQ Accordion functionality
document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.faq-section .accordion-header');

  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const accordionItem = this.parentElement;
      const accordionContent = accordionItem.querySelector('.accordion-content');
      const accordionIcon = this.querySelector('.accordion-icon');
      const isActive = accordionItem.classList.contains('active');

      // Close all accordion items
      document.querySelectorAll('.faq-section .accordion-item').forEach(item => {
        item.classList.remove('active');
        const content = item.querySelector('.accordion-content');
        const icon = item.querySelector('.accordion-icon');
        if (content) content.style.maxHeight = '0';
        if (icon) icon.textContent = '+';
      });

      // If the clicked item wasn't active, open it
      if (!isActive) {
        accordionItem.classList.add('active');
        // Calculate actual content height for smooth animation
        if (accordionContent) {
          const contentHeight = accordionContent.scrollHeight;
          accordionContent.style.maxHeight = contentHeight + 'px';
        }
        if (accordionIcon) accordionIcon.textContent = '−';
      }
    });
  });
});

// One-time purchase link handler
document.addEventListener('DOMContentLoaded', function() {
  const oneTimeLink = document.querySelector('.one-time-purchase-link');

  if (oneTimeLink) {
    oneTimeLink.addEventListener('click', function(e) {
      e.preventDefault();

      const variantId = this.getAttribute('data-variant-id');
      if (!variantId) {
        console.error('No variant ID found for one-time purchase');
        return;
      }

      console.log('One-time purchase - variant ID:', variantId);

      // Disable the link temporarily
      const originalText = this.innerHTML;
      this.style.opacity = '0.5';
      this.style.pointerEvents = 'none';

      // Create form data for the one-time purchase (no selling plan)
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      const packMonths = parseInt(this.getAttribute('data-pack-months') || '1', 10) || 1;
      if (this.hasAttribute('data-onetime-variant-1')) {
        formData.append('properties[_pack]', packMonths + ' Pack');
      }
      const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);
      if (sectionIds.length) {
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log('One-time purchase added to cart:', data);

        window.buyboxDispatchCartUpdate(data, 'one-time-purchase-link');

        // Re-enable the link after a short delay
        setTimeout(() => {
          this.style.opacity = '1';
          this.style.pointerEvents = 'auto';
        }, 1000);
      })
      .catch(error => {
        console.error('Error adding one-time purchase to cart:', error);
        this.style.opacity = '1';
        this.style.pointerEvents = 'auto';
      });
    });
  }
});

// Hide Seal Subscriptions elements
document.addEventListener('DOMContentLoaded', function() {
  function hideSealElements() {
    // Target specific Seal Subscriptions selectors
    const selectors = [
      '[class*="seal-subscription"]',
      '[id*="seal-subscription"]',
      '[class*="seal-widget"]',
      '[id*="seal-widget"]',
      '[data-seal-widget]',
      '.seal-subscriptions',
      '#seal-subscriptions-widget',
      '.sls-purchase-options-container',
      '.sls-more-info-container',
      '[class*="sls-"]'
    ];

    selectors.forEach(selector => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          element.style.display = 'none';
          element.style.visibility = 'hidden';
          element.style.opacity = '0';
          element.style.height = '0';
          element.style.overflow = 'hidden';
        });
      } catch (e) {
        // Ignore selector errors
      }
    });

    // Also check for elements with specific text content
    const textElements = document.querySelectorAll('*');
    textElements.forEach(element => {
      const text = element.textContent || '';
      if (text.trim() === 'Powered by Seal Subscriptions' ||
          text.trim() === 'Subscription details') {
        element.style.display = 'none';
      }
    });
  }

  // Run immediately
  hideSealElements();

  // Run again after delays to catch dynamically loaded content
  setTimeout(hideSealElements, 500);
  setTimeout(hideSealElements, 1500);
});

// Desktop lightbox for product images and videos
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 769) return;

  const overlay = document.getElementById('pdpLightbox');
  const lightboxImg = document.getElementById('pdpLightboxImg');
  const lightboxVideo = document.getElementById('pdpLightboxVideo');
  const dotsContainer = document.getElementById('pdpLightboxDots');
  const closeBtn = document.getElementById('pdpLightboxClose');
  const prevBtn = document.getElementById('pdpLightboxPrev');
  const nextBtn = document.getElementById('pdpLightboxNext');

  if (!overlay) return;

  // Collect all media (images and videos) from the carousel
  const media = [];
  const carouselItems = document.querySelectorAll('.wildtype-hero__carousel-item');
  carouselItems.forEach(item => {
    const video = item.querySelector('video');
    const img = item.querySelector('img');
    if (video) {
      const src = video.getAttribute('src');
      if (src) media.push({ src, type: 'video', el: item });
    } else if (img) {
      const src = img.getAttribute('src');
      if (src) media.push({ src, type: 'image', el: item });
    }
  });

  if (media.length === 0) return;

  let currentIdx = 0;

  // Build dots
  media.forEach((_, i) => {
    const dot = document.createElement('div');
    dot.className = 'pdp-lightbox-dot' + (i === 0 ? ' active' : '');
    dot.addEventListener('click', () => goTo(i));
    dotsContainer.appendChild(dot);
  });

  function goTo(idx) {
    currentIdx = idx;
    const item = media[idx];
    if (item.type === 'video') {
      lightboxImg.style.display = 'none';
      lightboxVideo.src = item.src;
      lightboxVideo.style.display = 'block';
      lightboxVideo.load();
      lightboxVideo.play().catch(() => {});
    } else {
      lightboxVideo.style.display = 'none';
      lightboxVideo.pause();
      lightboxVideo.src = '';
      lightboxImg.src = item.src;
      lightboxImg.style.display = 'block';
    }
    dotsContainer.querySelectorAll('.pdp-lightbox-dot').forEach((d, i) => {
      d.classList.toggle('active', i === idx);
    });
  }

  function open(idx) {
    goTo(idx);
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    lightboxVideo.pause();
    lightboxVideo.src = '';
    lightboxVideo.style.display = 'none';
    lightboxImg.style.display = 'block';
  }

  // Desktop shows only the first carousel item and swaps its media via thumbs.
  // Opening must use the active thumb index, not the static first-item index.
  function getDesktopOpenIndex(fallbackIdx) {
    const thumbs = Array.from(
      document.querySelectorAll('.wildtype-hero__carousel-thumbs .wildtype-hero__carousel-thumb')
    );
    if (!thumbs.length) return fallbackIdx;
    const activeIdx = thumbs.findIndex((t) => t.classList.contains('active'));
    if (activeIdx < 0 || activeIdx >= media.length) return fallbackIdx;
    return activeIdx;
  }

  // Attach click to each carousel item
  media.forEach((item, idx) => {
    item.el.style.cursor = 'zoom-in';
    item.el.addEventListener('click', (e) => {
      if (e.target.closest('.wildtype-hero__main-nav')) return;
      if (e.target.tagName === 'VIDEO') {
        const rect = e.target.getBoundingClientRect();
        if (e.clientY > rect.bottom - 40) return;
      }
      e.preventDefault();
      open(getDesktopOpenIndex(idx));
    });
  });

  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) close();
  });
  prevBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    goTo((currentIdx - 1 + media.length) % media.length);
  });
  nextBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    goTo((currentIdx + 1) % media.length);
  });

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (!overlay.classList.contains('active')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') goTo((currentIdx - 1 + media.length) % media.length);
    if (e.key === 'ArrowRight') goTo((currentIdx + 1) % media.length);
  });
});
